import React, { useState, useEffect } from 'react';
import { auth, db } from '../LoginComp/firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './main.css';
import { toast } from 'react-toastify';
import { collection, addDoc, serverTimestamp, getDocs } from 'firebase/firestore';



import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";










function MainPanel() {
  // const [activeTab, setActiveTab] = useState('addMember');
  // const [isLoggingOut, setIsLoggingOut] = useState(false);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const navigate = useNavigate();

  // const handleLogout = async () => {
  //   setIsLoggingOut(true);
  //   try {
  //     await signOut(auth);
  //     toast.success('Logged out successfully!');
  //     navigate('/', { replace: true });
  //   } catch (error) {
  //     console.error('Logout error:', error);
  //     toast.error('Logout failed. Please try again.');
  //   } finally {
  //     setIsLoggingOut(false);
  //   }
  // };

  // const handleTabClick = (tab) => {
  //   if (tab === 'logout') {
  //     handleLogout();
  //     return;
  //   }
  //   setActiveTab(tab);
  // };

  // // Form state of add member
  // const [formData, setFormData] = useState({
  //   registrationNo: '',
  //   fullName: '',
  //   nicNo: '',
  //   phoneNo: '',
  //   address: '',
  //   province: '',
  //   district: '',
  //   city: '',
  //   certifiedBy: '',
  //   certifiedDate: '',
  //   certifierName: ''
  // });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
    
  //   try {
  //     // Add document to Firestore 'members' collection
  //     await addDoc(collection(db, 'members'), {
  //       ...formData,
  //       createdAt: serverTimestamp(),
  //       status: 'active'
  //     });
      
  //     toast.success('Member registered successfully!');
      
  //     // Reset form
  //     setFormData({
  //       registrationNo: '',
  //       fullName: '',
  //       nicNo: '',
  //       phoneNo: '',
  //       address: '',
  //       province: '',
  //       district: '',
  //       city: '',
  //       certifiedBy: '',
  //       certifiedDate: '',
  //       certifierName: ''
  //     });
  //   } catch (error) {
  //     console.error('Error adding document: ', error);
  //     toast.error('Failed to register member. Please try again.');
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const [activeTab, setActiveTab] = useState('addMember');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    registrationNo: '',
    fullName: '',
    nicNo: '',
    phoneNo: '',
    address: '',
    province: '',
    district: '',
    city: '',
    certifiedBy: '',
    certifiedDate: '',
    certifierName: ''
  });

  // ✅ Generate the next registration number
  const generateRegistrationNumber = async () => {
    const snapshot = await getDocs(collection(db, 'members'));
    const totalCount = snapshot.size + 1; // next number
    const formattedNumber = totalCount.toString().padStart(3, '0'); // e.g. 001
    const regNo = `VI-${formattedNumber}`;
    setFormData(prev => ({ ...prev, registrationNo: regNo }));
  };

  useEffect(() => {
    generateRegistrationNumber();
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await signOut(auth);
      toast.success('Logged out successfully!');
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed. Please try again.');
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleTabClick = (tab) => {
    if (tab === 'logout') {
      handleLogout();
      return;
    }
    setActiveTab(tab);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'members'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'active'
      });

      toast.success('Member registered successfully!');
      
      // Generate new registration number after successful registration
      generateRegistrationNumber();

      // Reset form except registration number
      setFormData(prev => ({
        ...prev,
        fullName: '',
        nicNo: '',
        phoneNo: '',
        address: '',
        province: '',
        district: '',
        city: '',
        certifiedBy: '',
        certifiedDate: '',
        certifierName: ''
      }));

    } catch (error) {
      console.error('Error adding document: ', error);
      toast.error('Failed to register member. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };










  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "members"));
        const membersData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMembers(membersData);
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  // Calculate analysis stats
  const totalMembers = members.length;
  const certifiedByOphthalmologist = members.filter(m => m.certifiedBy === "Ophthalmologist").length;
  const certifiedByOptometrist = members.filter(m => m.certifiedBy === "Optometrist").length;














//analysis report

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "members"));
        const membersData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMembers(membersData);
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

 

  // Province data for chart
  const provinceCounts = members.reduce((acc, member) => {
    acc[member.province] = (acc[member.province] || 0) + 1;
    return acc;
  }, {});

  const provinceData = Object.keys(provinceCounts).map(province => ({
    province,
    members: provinceCounts[province],
  }));













  return (
    <div className="main-panel">
      <div className="top-bar">
        <div 
          className={`tab ${activeTab === 'addMember' ? 'active' : ''}`}
          onClick={() => handleTabClick('addMember')}
        >
          <i className="fas fa-user-plus"></i>
          <span>Add Member</span>
        </div>
        <div 
          className={`tab ${activeTab === 'allMembers' ? 'active' : ''}`}
          onClick={() => handleTabClick('allMembers')}
        >
          <i className="fas fa-users"></i>
          <span>All Members</span>
        </div>
        <div 
          className={`tab ${activeTab === 'analysis' ? 'active' : ''}`}
          onClick={() => handleTabClick('analysis')}
        >
          <i className="fas fa-chart-line"></i>
          <span>Analysis</span>
        </div>
        <div 
          className={`tab logout ${activeTab === 'logout' ? 'active' : ''}`}
          onClick={() => handleTabClick('logout')}
        >
          {isLoggingOut ? (
            <div className="spinner"></div>
          ) : (
            <>
              <i className="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </>
          )}
        </div>
      </div>
      
      <div className="content">
        {activeTab === 'addMember' && 
          <div className="tab-content">
            <div className="form-container">
              <h2 className="form-title">Member Registration</h2>
              
              <form onSubmit={handleSubmit} className="member-form">
                <div className="form-row">
                  
                  <div className="form-group">
                    <label htmlFor="registrationNo">Registration No:</label>
                    <input
                      type="text"
                      id="registrationNo"
                      name="registrationNo"
                      value={formData.registrationNo}
                      readOnly      // 👈 prevent editing
                      required
                    />
                  </div>

                  
                  <div className="form-group">
                    <label htmlFor="fullName">Full Name:</label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nicNo">NIC No:</label>
                    <input
                      type="text"
                      id="nicNo"
                      name="nicNo"
                      value={formData.nicNo}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phoneNo">Phone No:</label>
                    <input
                      type="tel"
                      id="phoneNo"
                      name="phoneNo"
                      value={formData.phoneNo}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group full-width">
                  <label htmlFor="address">Address:</label>
                  <textarea
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="3"
                    required
                  ></textarea>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="province">Province:</label>
                    <select
                      id="province"
                      name="province"
                      value={formData.province}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Province</option>
                      <option value="Western">Western</option>
                      <option value="Central">Central</option>
                      <option value="Southern">Southern</option>
                      <option value="Northern">Northern</option>
                      <option value="Eastern">Eastern</option>
                      <option value="North Western">North Western</option>
                      <option value="North Central">North Central</option>
                      <option value="Uva">Uva</option>
                      <option value="Sabaragamuwa">Sabaragamuwa</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="district">District:</label>
                    <input
                      type="text"
                      id="district"
                      name="district"
                      value={formData.district}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group full-width">
                  <label htmlFor="city">City:</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group full-width">
                  <label>Certified By:</label>
                  <div className="radio-group">
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="certifiedBy"
                        value="Ophthalmologist"
                        checked={formData.certifiedBy === 'Ophthalmologist'}
                        onChange={handleInputChange}
                        required
                      />
                      <span className="radio-label">Ophthalmologist</span>
                    </label>
                    
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="certifiedBy"
                        value="Optometrist"
                        checked={formData.certifiedBy === 'Optometrist'}
                        onChange={handleInputChange}
                      />
                      <span className="radio-label">Optometrist</span>
                    </label>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="certifiedDate">Certified Date:</label>
                    <input
                      type="date"
                      id="certifiedDate"
                      name="certifiedDate"
                      value={formData.certifiedDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="certifierName">Certifier Name:</label>
                    <input
                      type="text"
                      id="certifierName"
                      name="certifierName"
                      value={formData.certifierName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="submit-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Registering...' : 'Register Member'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
        





        {activeTab === "allMembers" && (
        <div className="tab-content">
          <div className="members-container">
            <h2 className="section-title">All Members</h2>
            <div className="members-table-container">
              <table className="members-table">
                <thead>
                  <tr>
                    <th>Registration No</th>
                    <th>Full Name</th>
                    <th>NIC No</th>
                    <th>Phone No</th>
                    <th>Certified By</th>
                    <th>Certified Date</th>
                    <th>Certifier Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="no-data">Loading...</td>
                    </tr>
                  ) : members.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="no-data">
                        <i className="fas fa-users"></i>
                        <p>No members found</p>
                        <small>Add members using the "Add Member" tab</small>
                      </td>
                    </tr>
                  ) : (
                    members.map(member => (
                      <tr key={member.id}>
                        <td>{member.registrationNo}</td>
                        <td>{member.fullName}</td>
                        <td>{member.nicNo}</td>
                        <td>{member.phoneNo}</td>
                        <td>{member.certifiedBy}</td>
                        <td>{member.certifiedDate}</td>
                        <td>{member.certifierName}</td>
                        <td>{member.status}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}








      {activeTab === "analysis" && (
        <div className="tab-content">
          <div className="analysis-container">
            <h2 className="section-title">Member Analysis</h2>
            
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="stat-content">
                  <h3>Total Members</h3>
                  <p className="stat-value">{totalMembers}</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-eye"></i>
                </div>
                <div className="stat-content">
                  <h3>Certified by Ophthalmologist</h3>
                  <p className="stat-value">{certifiedByOphthalmologist}</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon">
                  <i className="fas fa-glasses"></i>
                </div>
                <div className="stat-content">
                  <h3>Certified by Optometrist</h3>
                  <p className="stat-value">{certifiedByOptometrist}</p>
                </div>
              </div>
            </div>

            <div className="chart-container">
              <h3>Members by Province</h3>
              {provinceData.length === 0 ? (
                <div className="chart-placeholder">
                  <i className="fas fa-chart-bar"></i>
                  <p>No data available</p>
                </div>
              ) : (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={provinceData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="province" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="members" fill="#8884d8" />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </div>
          </div>
        </div>
      )}









      </div>
    </div>
  );
}

export default MainPanel;